import { render, staticRenderFns } from "./FinancePayoutsPage.vue?vue&type=template&id=327b6e86&"
import script from "./FinancePayoutsPage.vue?vue&type=script&lang=js&"
export * from "./FinancePayoutsPage.vue?vue&type=script&lang=js&"
import style0 from "./FinancePayoutsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports